// extracted by mini-css-extract-plugin
export var copyableItem = "_a-0";
export var underlined = "_a-1";